import { AVAILABLE_LANGUAGES } from '$locale/constants';
import { NAMESPACE_ENTITY } from '@dfg/core-verification-data-structure-library';

export const MAX_BREADCRUMBS_SIZE = 3;

export const TOAST_ERROR_TIME = 5000;

export const MILISECONDS_IN_A_DAY = 86400000;

export const FORCE_MAJEURE_MAX_ITEMS_TO_SHOW = 2;

export const DASHBOARD_URL: { [key: string]: string } = {
  'user-profile': 'profile',
  verification: 'verification',
  manageAccount: 'manageAccount',
  home: 'home',
  'request-correction': 'requestCorrection'
};

export const webGlobalMockState = {
  screen: {
    isMobile: false
  },
  locale: {
    lang: AVAILABLE_LANGUAGES.en
  }
};

export const mobileGlobalMockState = {
  screen: {
    isMobile: true
  },
  locale: {
    lang: AVAILABLE_LANGUAGES.en
  }
};

export const VERIFICATION_LIST_PAGE_SIZE = 25;

export const NOT_AVAILABLE = 'N/A';

/**
 * Date filter button values used across dashboard modules.
 */
export const CLIENT_DATE_FILTER_VALUES = {
  TODAY: 'today',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  CUSTOM: 'custom'
} as const;

/**
 * Metric type values for case overview drilldown.
 * Used across cases-overview-detail and filtered-cases-list modules.
 */
export const CLIENT_METRIC_TYPE_VALUES = {
  AUTOMATED_APPROVED: 'AUTOMATED_APPROVED',
  AUTOMATED_REJECTED: 'AUTOMATED_REJECTED',
  MANUAL_APPROVED: 'MANUAL_APPROVED',
  MANUAL_REJECTED: 'MANUAL_REJECTED',
  MANUAL_PENDING_COMPLIANCE: 'MANUAL_PENDING_COMPLIANCE'
} as const;

/**
 * Reasoning type values for reasoning details.
 * Used across cases-overview-detail and reasoning-details modules.
 */
export const CLIENT_REASONING_TYPE_VALUES = {
  AUTOMATED: 'automated',
  MANUAL: 'manual'
} as const;

/**
 * Fallback dash character used when data is unavailable.
 */
export const CLIENT_FALLBACK_DASH = '-';

/**
 * Common icon sizes used across dashboard components.
 */
export const CLIENT_ICON_SIZES = {
  SM: '14',
  MD: '16',
  LG: '20'
} as const;

/** True when client namespace is DMW (DMW-specific flows). */
export const isDmw = (): boolean => {
  const raw = process.env.NEXT_PUBLIC_DEFAULT_NAMESPACE ?? '';
  return raw.trim().toUpperCase() === NAMESPACE_ENTITY.DMW;
};
